export default __webpack_public_path__ + "static/Alegreya-Regular-0a7e77e595f15bb4c3129c198f30ae29.ttf";